import React, { createContext, useContext } from 'react';
import { useHideFooter } from '../hooks/useLocalStorage';

type HideFooterContextType = ReturnType<typeof useHideFooter>;

const HideFooterContext = createContext<HideFooterContextType | null>(null);

export const HideFooterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useHideFooter();
  return (
    <HideFooterContext.Provider value={value}>
      {children}
    </HideFooterContext.Provider>
  );
};

export function useHideFooterContext(): HideFooterContextType {
  const ctx = useContext(HideFooterContext);
  if (!ctx) throw new Error('useHideFooterContext must be used within HideFooterProvider');
  return ctx;
}
